import API from './axios.js';

export const saveContacForm = (payload) => API.post('contact', payload);